/* eslint-disable max-len */
export const findLocation = state => id => state.all.find(l => l.id === id);
export const findLocationByUUID = state => uuid => state.all.find(l => l.uuid === uuid);
export const getDefaultLocation = state => state.all[0];
export const getDeliveryMethod = state => payload => state.deliveryMethods.find(entry => entry.id === payload);
export const getPaymentMethod = state => payload => state.paymentMethods.find(entry => entry.id === payload);
export const getDeliveryMethodWaitingTime = state => payload => state.current.waitingTimes.find(entry => entry.deliveryMethodId === payload);
export const getDefaultPaymentMethod = (state) => {
  const cardMethod = state.paymentMethods.find(v => v.type === 1);
  if (cardMethod) {
    return cardMethod;
  }

  return state.paymentMethods[0];
};
